import React, { useEffect, useRef } from 'react';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-bs5'; // Ensure this is imported for Bootstrap 5 integration

DataTable.use(DT)

function DataTableComponent({ columns, order }) {
  const tableRef = useRef(null);

  useEffect(() => {
    if (tableRef.current) {
      console.log("Initializing DataTable with ", columns);
    }
  }, [columns]);

  return (
    <DataTable
      ref={tableRef}
      options={{
        processing: true,
        serverSide: true,
        pageLength: 25,
        order: order || [0, 'desc'], // Use the order prop here
        scrollX: true,
        ajax: {
          type: 'PATCH',
          headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
          },
          data: function(d) {
            d.from_search = document.activeElement.type === 'search';
            return d;
          }
        },
        columns: Object.keys(columns).map(key => {
          return { data: key, className: 'text-nowrap' }
        }),
        columnDefs: Object.values(columns).map((value, index) => {
          return { target: index, title: value, orderSequence: ['desc', 'asc'], }
        }),
        drawCallback: function(settings) {
          window.localizeTimestamps();

          $('[data-url]').off('click');
          $('[data-url]').on('click', function() {
            window.location.href = $(this).data('url');
          });
        }
      }}
      className="table table-striped table-bordered table-hover"
    />
  );
}

export default DataTableComponent;